import { oxgCloseModal, oxgCloseModalAnimated, oxgCreateLoadingOverlay, oxgRemoveLoadingOverlay } from "../../modules/modals"

window.oxgDeleteBriefingDraft = (id, type)=> {
  oxgCreateLoadingOverlay()
  const jq = jQuery
    jq.ajax({
        url: ajax_obj.ajax_url,
        type: 'POST',
        data: {
          action: 'oxg_delete_briefing_draft',
          data: {
            id: id,
            type: type,
          }
        },
        success: function(response) {
          console.log(response)
          oxgRemoveLoadingOverlay()
          if (response.data.event == 'success') {
            console.log(response)
            window.open(window.location.origin + '/drafts?msg=' + response.data.message + '&msg_type=success' + '&sb_docked=0', '_self')
          } else {
            alert(response.data.message)
            oxgCloseModal('ddc')
          }
        },
        error: function(response) {
          console.error(response)
          oxgCloseModalAnimated('ddc')
          oxgRemoveLoadingOverlay() 
          window.open(window.location.origin + '/response?event=' + response.data.event + '&success=false&message=' + response.data.message, '_self')
        }
    });
}

window.oxgAfterDeleteBriefingModalOpen = ()=> {
  //console.log('the delete briefing confirmation modal just opened up')
}